import React from 'react';
import { Tooltip } from '@mui/material';
var NodeLabel = function (_a) {
    var label = _a.label, maxLabelLength = _a.maxLabelLength, textColor = _a.textColor;
    var trimmedLabel = label.length <= maxLabelLength ? label : label.slice(0, maxLabelLength).concat('...');
    return (React.createElement(Tooltip, { title: label },
        React.createElement("text", { className: 'interactiveNode__label', style: {
                fill: textColor,
            } }, trimmedLabel)));
};
export default NodeLabel;
//# sourceMappingURL=NodeLabel.js.map